// extracted by mini-css-extract-plugin
module.exports = {"Notifications":"Notifications_Notifications__3u4D9","countBadge":"Notifications_countBadge__Vwq_1","popover":"Notifications_popover__1bGWX"};